/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var KonturInstallIcon20Regular = forwardRef('KonturInstallIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M11.406 10.523a1.5 1.5 0 1 0-.884.884l2.536 2.535a.625.625 0 1 0 .884-.884l-2.536-2.535Z" }),
        React.createElement("path", { d: "M9.847 6.128a.625.625 0 0 1-.05-1.249 5.187 5.187 0 0 1 4.151 1.853 5.187 5.187 0 0 1 1.045 4.425.625.625 0 1 1-1.218-.282 3.922 3.922 0 0 0-.79-3.346 3.922 3.922 0 0 0-3.138-1.401Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 2.001A7.999 7.999 0 1 0 10 18 7.999 7.999 0 0 0 10 2Zm-6.499 8A6.499 6.499 0 1 1 16.5 10 6.499 6.499 0 0 1 3.5 10Z" })));
});
